import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

const BASE_URL = process.env.REACT_APP_API_BASE_URL

export const fetchCourses = createAsyncThunk(
  'courses/fetchCourses',
  async (token, { rejectWithValue }) => {
    try {
      const [enrolledRes, activeRes, completedRes] = await Promise.all([
        axios.get(`${BASE_URL}/users/my-courses/enrolled/`, {
          headers: { Authorization: `Bearer ${token}` },
        }),
        axios.get(`${BASE_URL}/users/my-courses/active/`, {
          headers: { Authorization: `Bearer ${token}` },
        }),
        axios.get(`${BASE_URL}/users/my-courses/completed/`, {
          headers: { Authorization: `Bearer ${token}` },
        }),
      ])

      // Function to fetch progress for each course
      const fetchProgress = async (courses) => {
        return await Promise.all(
          courses.map(async (item) => {
            const courseDetailResponse = await axios.get(
              `${BASE_URL}/courses/${item.course.id}/`,
              { headers: { Authorization: `Bearer ${token}` } }
            )
            return {
              id: item.course.id,
              course: {
                id: item.course.id,
                title: item.course.title,
                image: item.course.image || '/placeholder.svg',
                average_rating: item.course.average_rating || 0,
                review_count: item.course.review_count || 0,
                progress: {
                  completed: courseDetailResponse.data.progress.completed,
                  total: courseDetailResponse.data.progress.total,
                  percentage: courseDetailResponse.data.progress.percentage,
                },
              },
            }
          })
        )
      }

      return {
        enrolled: await fetchProgress(enrolledRes.data.results || []),
        active: await fetchProgress(activeRes.data.results || []),
        completed: await fetchProgress(completedRes.data.results || []),
      }
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message)
    }
  }
)

const courseSlice = createSlice({
  name: 'courses',
  initialState: {
    enrolled: [],
    active: [],
    completed: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCourses.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchCourses.fulfilled, (state, action) => {
        state.loading = false
        state.enrolled = action.payload.enrolled
        state.active = action.payload.active
        state.completed = action.payload.completed
      })
      .addCase(fetchCourses.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
  },
})

export default courseSlice.reducer